(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-triple-video-vertical"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('product-triple-video')) return;

    customElements.define('product-triple-video', class extends HTMLElement {
      connectedCallback() {
        // Wait for children when Shopify inserts a new section into the editor.
        this.setupTimer = window.setTimeout(() => this.setup(), 0);
      }

      setup() {
        this.videos = Array.from(this.querySelectorAll('.ptvv-video'));
        if (!this.videos.length) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.button = this.querySelector('.ptvv-toggle');
        this.status = this.querySelector('.ptvv-status');
        this.actions = this.querySelector('.ptvv-actions');
        this.wanted = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.visible = !('IntersectionObserver' in window);
        this.running = false;
        this.starting = false;
        this.failed = false;
        this.attempt = (this.attempt || 0) + 1;

        this.button.addEventListener('click', () => {
          this.stop();
          this.wanted = true;
          this.start(true);
          this.updateButton();
        }, options);

        this.videos.forEach((video) => {
          video.muted = true;
          video.defaultMuted = true;
          video.addEventListener('canplay', () => this.start(), options);
          video.addEventListener('seeked', () => this.start(), options);
          video.addEventListener('ended', () => this.restart(), options);
          video.addEventListener('error', () => this.fail(), options);
          const source = video.querySelector('source');
          if (source) source.addEventListener('error', () => this.fail(), options);
          if (video.error || video.networkState === 3) this.fail();
        });

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.stop();
          else this.start();
        }, options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(([entry]) => {
            this.visible = entry.isIntersecting;
            if (this.visible) this.start();
            else this.stop();
          });
          this.observer.observe(this);
        }

        this.timer = window.setInterval(() => this.synchronize(), 150);
        this.updateButton();
        this.start();
      }

      updateButton() {
        this.button.textContent = this.button.dataset.playLabel || 'Lire les videos';
        this.button.hidden = this.wanted || this.failed;
        this.actions.hidden = this.wanted && !this.failed;
      }

      stop() {
        this.attempt += 1;
        this.running = false;
        this.starting = false;
        this.videos.forEach((video) => video.pause());
        this.updateButton();
      }

      start(userGesture = false) {
        if (!this.wanted || (!this.visible && !userGesture) || document.hidden || this.failed || this.running || this.starting) return;
        this.starting = true;
        const attempt = ++this.attempt;
        // iOS can defer preload: call play() before waiting for canplay, including on a tap.
        const requests = this.videos.map((video) => {
          video.muted = true;
          try { return Promise.resolve(video.play()); }
          catch (error) { return Promise.reject(error); }
        });
        Promise.all(requests).then(() => {
          if (attempt !== this.attempt) return;
          this.starting = false;
          this.running = true;
          this.align();
          this.updateButton();
        }).catch(() => {
          if (attempt !== this.attempt) return;
          this.stop();
          this.wanted = false;
          this.updateButton();
        });
      }

      restart() {
        this.stop();
        // A common loop ends at the shortest clip, so different lengths cannot drift.
        this.videos.forEach((video) => { video.currentTime = 0; });
        this.start();
      }

      synchronize() {
        if (!this.running) return;
        if (this.videos.some((video) => video.ended)) {
          this.restart();
          return;
        }
        if (this.videos.some((video) => video.paused)) {
          this.wanted = false;
          this.stop();
          return;
        }
        this.align();
      }

      align() {
        // Keep the slowest clip as the reference, including while it is buffering.
        if (this.videos.some((video) => video.readyState < 2 || video.seeking)) return;
        const time = Math.min(...this.videos.map((video) => video.currentTime));
        this.videos.forEach((video) => {
          if (video.currentTime - time > 0.15) {
            video.currentTime = time;
          }
        });
      }

      fail() {
        this.failed = true;
        this.stop();
        this.wanted = false;
        this.updateButton();
        this.button.disabled = true;
        this.status.textContent = 'Une video est indisponible.';
      }

      disconnectedCallback() {
        window.clearTimeout(this.setupTimer);
        window.clearInterval(this.timer);
        if (this.events) this.events.abort();
        if (this.observer) this.observer.disconnect();
        if (this.videos && this.videos.length) this.stop();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
